var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_377_267)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9995 17.6191C19.5518 17.6191 19.9995 18.0669 19.9995 18.6191C19.9995 19.1714 19.5518 19.6191 18.9995 19.6191H9.99951C9.44723 19.6191 8.99951 19.1714 8.99951 18.6191C8.99951 18.0669 9.44723 17.6191 9.99951 17.6191H18.9995Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.897 0.380859C16.2498 0.380859 16.5994 0.450356 16.9254 0.584961C17.2515 0.719726 17.5488 0.917995 17.7984 1.16699C18.0479 1.41597 18.2464 1.71186 18.3814 2.03711C18.5164 2.36234 18.5855 2.71147 18.5855 3.06348C18.5855 3.41524 18.5162 3.76384 18.3814 4.08887C18.2463 4.41422 18.048 4.71093 17.7984 4.95996L4.97809 17.749C4.91244 17.8145 4.82987 17.8613 4.73981 17.8838L0.637268 18.9072C0.462569 18.9507 0.277291 18.8995 0.149963 18.7725C0.0228394 18.6455 -0.0282729 18.4612 0.0151978 18.2871L1.04059 14.1943C1.06313 14.1044 1.11061 14.0216 1.17633 13.9561L13.9957 1.16699C14.4998 0.664105 15.1841 0.380885 15.897 0.380859Z",
    fill: "#999999"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_377_267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 19.2383,
    fill: "white",
    transform: "translate(0 0.380859)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPen);
export default __webpack_public_path__ + "static/media/icon-pen.bfe34ea7c7342f42f09dde41bbfea562.svg";
export { ForwardRef as ReactComponent };